import { SortNumericVariantIcon } from './SortNumericVariantIcon';

/**
 * author: Google
 * id 2CD8E0F3-0AF4-4BBD-B1C8-EEF6391F62C3
 * name sort-numeric-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-numeric-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const SortNumericallyIcon = SortNumericVariantIcon;
export default SortNumericallyIcon